import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError, EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthService } from '../security/auth.service'
import {Router} from "@angular/router";
import {FORBIDDEN, FORBIDDEN_MESSAGE} from "../common/Constants";
import {getMedicationBatchUploadDisplayMessage} from "../medication-alerts/batch-upload.utils";
import {MessageHandlerService} from "../services/message-handler.service";
import {ProgressBarService} from "../services/progress-bar.service";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthService, protected router: Router,
                private messageHandlerService: MessageHandlerService,
                private readonly progressBarService: ProgressBarService,) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
              if(err.status === 401){
                this.authenticationService.signOut();
              }

            if (err.status === 403 || err.status === 400 || err.status === 500) {
              const isBatchUpload = err.status === 400 && request.url?.includes('medication-alerts/batch-upload');
              if (isBatchUpload && Array.isArray(err?.error?.errors) && err.error.errors.length > 0) {
                this.progressBarService.setProgressBarVisibility(false);
                return throwError(() => err);
              }

              const rawMessage = err?.error?.message;
              const displayMessage = isBatchUpload
                ? getMedicationBatchUploadDisplayMessage(rawMessage)
                : (rawMessage || FORBIDDEN_MESSAGE);
              this.messageHandlerService.generateToastMessage(
                'error',
                isBatchUpload ? '' : FORBIDDEN,
                displayMessage
              );
              this.progressBarService.setProgressBarVisibility(false);
              // Return EMPTY instead of null to prevent RxJS "null where stream expected" error
              // This completes the Observable without emitting, so components won't trigger error handlers
              return EMPTY;
            }

            const error = err.error.message || err.statusText;
            return throwError(error);
        }))
    }
}
